import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useMemo } from "react";

const useStyles = makeStyles({
  root: {
    border: 0,
    color: 'text.primary',
    height: 'auto',
    width: '100%',
    overflow: 'hidden'
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  }
});

export const EconomicsNI51101Table4Table = ({ economics }) => {

  // STYLES
  const classes = useStyles();
  const currency = economics?.settings?.currency;

  const rows = useMemo(() => {
    try {
      const data = [];
      const wellType = economics?.economicVolumesGross?.oil > 0 ? 'oil' : 'gas';

      data.push({
        id: 'proved-1',
        category: 'Proved',
        productType: 'Light and Medium Crude Oil (including solution gas and associated byproducts)',
        npv10BTax: 0,
        unitValue: 0
      });

      data.push({
        id: 'proved-2',
        category: '',
        productType: 'Conventional Natural Gas (Non-Assoc. & Assoc.) (including associated byproducts)',
        npv10BTax: 0,
        unitValue: 0
      });

      data.push({
        id: 'proved-3',
        category: '',
        productType: 'Total',
        npv10BTax: 0,
        unitValue: 0
      });

      data.push({
        id: 'probable-1',
        category: 'Proved Plus Probable',
        productType: 'Light and Medium Crude Oil (including solution gas and associated byproducts)',
        npv10BTax: wellType === 'oil' ? Number((economics?.npvNet?.cashflowBTax?.[2] / 1000)?.toFixed(2)) : 0,
        unitValue: wellType === 'oil' ? Number((economics?.npvNet?.cashflowBTax?.[2] / economics?.cashflowNet.reduce((tot, curr) => tot + curr.boe, 0))?.toFixed(2)) : 0
      });

      data.push({
        id: 'probable-2',
        category: '',
        productType: 'Conventional Natural Gas (Non-Assoc. & Assoc.) (including associated byproducts)',
        npv10BTax: wellType === 'gas' ? Number((economics?.npvNet?.cashflowBTax?.[2] / 1000)?.toFixed(2)) : 0,
        unitValue: wellType === 'gas' ? Number((economics?.npvNet?.cashflowBTax?.[2] / economics?.cashflowNet.reduce((tot, curr) => tot + curr.boe, 0))?.toFixed(2)) : 0
      });

      data.push({
        id: 'probable-3',
        category: '',
        productType: 'Total',
        npv10BTax: Number((economics?.npvNet?.cashflowBTax?.[2] / 1000)?.toFixed(2)) || 0,
        unitValue: Number((economics?.npvNet?.cashflowBTax?.[2] / economics?.cashflowNet.reduce((tot, curr) => tot + curr.boe, 0))?.toFixed(2)) || 0
      });

      return data;

    } catch (error) {
      return [];
    };
  }, [economics]);

  const columns = useMemo(() => {
    return [
      {
        field: 'category',
        headerName: 'Category',
        width: 150,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'productType',
        headerName: `Product Type`,
        width: 500,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv10BTax',
        headerName: `Future Net Rev. b/ Tax (M ${currency?.toUpperCase()})`,
        width: 150,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'unitValue',
        headerName: `Unit Value (${currency?.toUpperCase()}/boe)`,
        width: 150,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      }     
    ];
  }, [currency]);

  try {

    if (rows) {
      return (
        <div className={classes.root}>
          <DataGrid
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[10,25,50,100]}
            disableSelectionOnClick
            className={classes.table}
            components={{
              Toolbar: GridToolbar,
            }}
            sx={{fontSize: 12}}
            rowHeight={24}
            autoHeight={true}
          />
        </div>
      );
    } else {
      return <></>;
    };

  } catch (error) {
    return <></>
  };

};
